// extracted by mini-css-extract-plugin
export var pillWrapper = "_qj-0";
export var showOverflow = "_qj-1";